import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AfterLoginGuard implements CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.auth.alreadyLoggedIn()) {
      if (route.data?.['accountTypeRestriction']) {
        if (
          this.auth.getAccountType() == route.data['accountTypeRestriction']
        ) {
          return true;
        } else {
          return false;
        }
      } else return true;
    } else return this.router.navigate(['', 'auth', 'login']);
  }
}
